module.exports = __webpack_public_path__ + "static/media/squares-concentric-circles.46182d67.jpg";